import { render, staticRenderFns } from "./AddCompetition.vue?vue&type=template&id=7b3fdb5f&"
import script from "./AddCompetition.vue?vue&type=script&lang=js&"
export * from "./AddCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/AddCompetition.vue
// module id = null
// module chunks = 